import { SETTINGS_KEYS } from "@/constants/settings-keys";
import { useCalendarCapacitiesOptions } from "@/hooks/queries/calendar-capacities.queries";
import { useSettings } from "@/providers/general/settings-provider";

import {
    toggleAllCalendarCapacitySelection,
    toggleCalendarCapacitySelection,
} from "../utils/calendar-capacities.utils";

type UseCalendarCapacitiesSelectionReturn = {
    selectedCalendars: string[];
    allCalendarNames: string[];
    toggleCalendar: (name: string) => void;
    toggleAllCalendars: () => void;
};

/**
 * Manages which calendars are shown on the Calendar Capacities page and dashboard widget.
 */
export function useCalendarCapacitiesSelection(): UseCalendarCapacitiesSelectionReturn {
    const { currentSettings, setValue } = useSettings();
    const { allCalendarNames } = useCalendarCapacitiesOptions();

    const selectedCalendars = currentSettings[SETTINGS_KEYS.CALENDAR_CAPACITIES_VISIBLE] ?? [];

    const toggleCalendar = (name: string) => {
        const next = toggleCalendarCapacitySelection(selectedCalendars, name);
        setValue(SETTINGS_KEYS.CALENDAR_CAPACITIES_VISIBLE, next);
    };

    const toggleAllCalendars = () => {
        const next = toggleAllCalendarCapacitySelection(selectedCalendars, allCalendarNames);
        setValue(SETTINGS_KEYS.CALENDAR_CAPACITIES_VISIBLE, next);
    };

    return {
        selectedCalendars,
        allCalendarNames,
        toggleCalendar,
        toggleAllCalendars,
    };
}
